import wrapper from 'wrapper';

class Filters {
    constructor() {
        this.filterContainer = wrapper.select('.facewall-filters-buttons');
        this.filters = __('facewall-configurations_1_filters').split(',').map(filter => filter.trim());
        this.cardList = wrapper.selectAll('.card-list-item');
        this.cardOrder = this.getCardOrder();
        this.renderFilters();
    }

    renderFilters() {
        this.setNumberOfCardsHeader();
        this.filters.forEach(property => {
            const radioInput = this.createFilterButton(property);

            radioInput.addEventListener('click', () => {
                this.unfilterResults();
                this.filterResults(radioInput.value);
                this.setNumberOfCardsHeader();
            });
        });
    }

    createFilterButton(category) {
        const radioInput = document.createElement('input');
        const label = document.createElement('label');

        const className = category.split(' ').join('-');

        radioInput.setAttribute('id', `radio-${className}`);
        label.setAttribute('for', `radio-${className}`);

        radioInput.setAttribute('name', 'filter-radio');
        radioInput.setAttribute('type', 'radio');
        radioInput.setAttribute('value', category);

        // Default selected radio button 'All'
        if (category === this.filters[0]) {
            radioInput.setAttribute('checked', 'checked');
        }

        label.innerHTML = category;

        this.filterContainer.appendChild(radioInput);
        this.filterContainer.appendChild(label);

        return radioInput;
    }

    filterResults(category) {
        this.isFiltered = (category !== this.filters[0]);
        this.numberOfDisplayedCards = this.cardList.length;
        this.cardList.forEach((card, i) => {
            card.classList.remove('filtered');
            const filterList = __(`card_${this.cardOrder[i]}_filters`) || '';
            const cardFilters = filterList.split(',').map(filter => filter.trim());
            if (!cardFilters.includes(category)) {
                card.style.display = 'none'; // eslint-disable-line
                this.numberOfDisplayedCards -= 1;
            }
            else {
                card.classList.add('filtered');
            }
        });
    }

    unfilterResults() {
        this.cardList.forEach((card, i) => {
            card.style.display = 'inline-block'; // eslint-disable-line
        });
    }

    setNumberOfCardsHeader() {
        const subHeader = wrapper.select('.header-container__facewall-subheader');
        if (!this.isFiltered) {
            subHeader.innerHTML =
                `${__('facewall-header_1_facewall_total_cards')} <span class="key-stat">${this.cardList.length}</span>`;
        }
        else {
            subHeader.innerHTML =
                `<span class="key-stat">${this.numberOfDisplayedCards}</span>
                ${__('facewall-header_1_facewall_filter_num_cards')}
                ${this.cardList.length}`;
        }
    }

    getCardOrder() {
        const cardOrder = [];
        this.cardList.forEach(card => {
            if (!(card.style.display === 'none')) {
                cardOrder.push(card.querySelector('.card').getAttribute('data-id'));
            }
        });
        return cardOrder;
    }
}

export default Filters;
